import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Constant } from 'src/app/common/constant/constant';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ThreadService } from 'src/app/services/thread/thread.service';
import { ConfirmationComponent } from 'src/app/components/common/confirmation/confirmation.component';
import { PaymentPopupComponent } from 'src/app/components/common/payment-popup/payment-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-stripe-cards',
  templateUrl: './stripe-cards.component.html',
  styleUrls: ['./stripe-cards.component.scss']
})
export class StripeCardsComponent implements OnInit {
  @Input() access:string = 'view';
  @Input() cardAction: boolean = false;
  @Input() shopId: any = 0;
  @Input() email: any = '';
  @Input() stripeData: any = [];
  @Output() stripeCardCompoentRef: EventEmitter<StripeCardsComponent> = new EventEmitter();
  @Output() stripeCardCallBack: EventEmitter<StripeCardsComponent> = new EventEmitter();
  @Output() stripeInvoicdCardCallBack: EventEmitter<StripeCardsComponent> = new EventEmitter();

  public modalConfig: object = { backdrop: 'static', keyboard: false, centered: true, windowClass: 'payment-popup', class: 'modal-dialog-centered' };
  public stripeCustomer: any = null;
  public cardList: any = [];
  public primaryCard: any = '';
  public user: any;
  public domainId: any;
  loader = true;
  paymentPopupOpen: boolean;
  paymentLoading: boolean;
  paymentDonePopup: boolean;
  paymentFailurePopup: boolean;
  newCardFail: boolean;
  actionPopup = false;
  cardDeleteConfirm = false;
  actionType = '';
  cardId: any = '';
  public customerList: any=[];
  
  constructor(
    private modalService: NgbModal,
    private authenticationService: AuthenticationService,
    private threadApi: ThreadService
  ) { }

  ngOnInit(): void {
    this.user = this.authenticationService.userValue;
    this.domainId = this.user.domain_id;
    console.log(this.stripeData)
    if(!Array.isArray(this.stripeData)) {
      this.stripeCustomer = this.stripeData.customer;
      this.cardList = this.stripeData.cards;
      this.customerList = this.stripeData.customer;
      if(this.stripeCustomer != null) {
        this.primaryCard = this.stripeCustomer.invoice_settings.default_payment_method;
        this.setupCard();
      }
    }
    this.stripeCardCompoentRef.emit(this);
    console.log(this.stripeData);
  }

  createNewCard() {
    this.paymentLoading = false;
    this.paymentFailurePopup = false;
    this.newCardFail = false;

    const modelRef = this.modalService.open(PaymentPopupComponent, this.modalConfig);
    modelRef.componentInstance.newCard = true;
    modelRef.componentInstance.domainId = this.domainId;
    modelRef.componentInstance.confirmAction.subscribe((recivedService) => {
      modelRef.close('Cross click');
      if (!recivedService) {
        return;
      } else {
        window.close();
      }
    });
    modelRef.componentInstance.paymentResponse.subscribe((res) => {
      let apiInfo = {
        apiKey: Constant.ApiKey,
        userId: this.user.Userid,
        domainId: this.domainId,
        token: res.token,
        cardHolderName: res.cardholderName,
        email: this.user.Email,
        shopId: this.shopId,
        action: 'new'
      }
      this.loader = true;
      this.threadApi.apiSetupCard(apiInfo).subscribe((response)=>{
        console.log(response)
        if (response.status == 'Success') {
          let resultData = response.data;
          this.cardList = resultData.cards;
          this.stripeCustomer = resultData.customer;
          this.primaryCard = this.stripeCustomer.invoice_settings.default_payment_method;
          this.setupCard('Success');
        } else {
          this.newCardFail = true;
          this.loader = false;
          this.paymentLoading = true;
          this.paymentFailurePopup = true;
        }
      })
      modelRef.close('Cross click');
    });
  }

  setupCardAction(action, cardId) {
    this.actionType = action;
    let access = 'alert';
    let saction = (this.actionType == 'delete') ? 'delete this card' : 'set this card as primary'
    let title = `Are you sure you'd like to ${saction}?`
    const modalRef = this.modalService.open(ConfirmationComponent, { backdrop: 'static', keyboard: false, centered: true });
    modalRef.componentInstance.access = access;
    modalRef.componentInstance.bodyTxtAlert = title;
    modalRef.componentInstance.confirmAction.subscribe((receivedService) => {
      modalRef.dismiss('Cross click');
      console.log(receivedService);
      if(receivedService) {
        if(cardId) {
          this.cardId = cardId;  
        }
        this.submitAction(this.actionType);
      }
    });
  }

  submitAction(action) {
    this.loader = true;
    this.actionPopup = false;
    let apiInfo = {
      apiKey: Constant.ApiKey,
      userId: this.user.Userid,
      domainId: this.domainId,
      shopId: this.shopId,
      cardId: this.cardId,
      action: action
    }
    this.threadApi.apiSetupCard(apiInfo).subscribe((response)=>{
      console.log(response)
      this.loader = false;
      this.actionType = "";
      this.cardId = "";
      if (response.status == 'Success') {
        let resultData = response.data;
        this.cardList = resultData.cards;
        this.stripeCustomer = resultData.customer;
        if(action == 'primary') {
          this.primaryCard = this.stripeCustomer.invoice_settings.default_payment_method;
        }
        this.setupCard();
      }
    });
  }

  setupCard(action='') {
    let primaryCardIndex = this.cardList.findIndex(x => x.id == this.primaryCard);
    if (primaryCardIndex > -1) {
      let primaryCard = this.cardList.splice(primaryCardIndex, 1)[0];
      this.cardList.splice(0, 0, primaryCard);
    }
    if(this.access == 'invoice-manage' && action == 'Success'){
      this.stripeInvoicdCardCallBack.emit(this);
    }
  }

}
